import { createContext, useContext } from 'react';
import { TaskFlowContextValue } from '../types/taskFlow.types';

export const TaskFlowContext = createContext<TaskFlowContextValue | null>(null);

export const useTaskFlow = () => {
    const context = useContext(TaskFlowContext);
    if (!context) {
        throw new Error('useWorkFlow must be used within a WorkFlowProvider');
    }
    return context;
}; 